<div class="filter-form-container view">
    @if (isLoading) {
        <div class="loading">
            <mat-spinner color="accent" diameter="40"></mat-spinner>
            <p>Loading filter…</p>
        </div>
    }

    @if (error) {
        <div class="error-message">
            <mat-icon>error</mat-icon>
            <p>{{ error }}</p>
        </div>
    }

    @if (!isLoading) {
        <mat-card class="cardPlain">
            <div class="custom-card-header">
                <div class="section-header">
                    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
        <h1 class="m-0 f-w-500">
          {{ editingFilter ? (filterForm.get('name')?.value || editingFilter.name) : isEditMode ? 'Filter' : 'New filter' }}
        </h1>
                    @if (editingFilter) {
                        <p class="m-0 help-text">Last updated: {{ editingFilter.updatedAt | date: 'medium' }}</p>
                    }
                    @if (!editingFilter && !isEditMode) {
                        <p class="m-0 help-text">Create an import filter for company imports into HubSpot.</p>
                    }
                </div>
                <span class="spacer"></span>
                @if (editingFilter) {
                    <span
                            [ngClass]="filterForm.get('enabled')?.value ? 'status-enabled' : 'status-disabled'"
                            class="status-pill"
                    >
	          <mat-icon>{{ filterForm.get('enabled')?.value ? 'check_circle' : 'pause_circle' }}</mat-icon>
                        {{ filterForm.get('enabled')?.value ? 'Enabled' : 'Disabled' }}
	        </span>
                }
            </div>

    <mat-card-content class="d-flex flex-col gap-24">
      <form [formGroup]="filterForm" (ngSubmit)="saveFilter()" class="tab-content d-flex flex-col gap-24">
          <p class="f-s-14" aria-live="polite">
            @if (facets.loading()) { Updating filter options… }
            @else if (facets.error()) { {{ facets.error() }} <button mat-button type="button" (click)="facets.retry()">Retry</button> }
            @else { Options and counts reflect the other active filters. }
          </p>
        <section class="tab-section d-flex flex-col gap-16">
          <div class="section-header">
            <h4 class="m-0 f-s-16 f-w-600">Basic details</h4>
            <p class="m-0 f-s-14 text-gray-100">Name and description for the filter.</p>
          </div>

          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Filter name</mat-label>
                <input matInput formControlName="name" placeholder="Enter filter name" required />
                  @if (filterForm.get('name')?.hasError('required')) {
                      <mat-error>Filter name is required</mat-error>
                  }
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" placeholder="Enter filter description" rows="1"></textarea>
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-slide-toggle formControlName="enabled">Filter enabled</mat-slide-toggle>
              @if (localSearchOnly) {
                <p class="help-text">Local search mode: filters are saved as inactive. HubSpot import and automatic sync are disabled.</p>
              }
            </div>
          </div>
        </section>

        <section formGroupName="criteria" class="tab-section d-flex flex-col gap-16">
          <div class="section-header">
            <h4 class="m-0 f-s-16 f-w-600">Filter criteria</h4>
            <p class="m-0 f-s-14 text-gray-100">Define which companies match this import filter.</p>
          </div>

          <div class="section-header">
            <h5 class="m-0 f-s-14 f-w-600">Basic filters</h5>
          </div>

          <div class="row">
            <div class="col-12 col-md-6">
              <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="NACE code" formControlName="nace_code1"
                  [options]="filterOptions['nace_code1'] || []"></app-filter-multiselect>
            </div>

            <div class="col-12 col-md-6">
              <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Employee group" formControlName="number_of_employees_group"
                  [options]="filterOptions['number_of_employees_group'] || []"></app-filter-multiselect>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Postal code</mat-label>
                <input matInput formControlName="postal_code" placeholder="Enter postal code" />
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Region" formControlName="region" (selectionChange)="regionSelectionChanged = true"
                  [options]="filterOptions['region'] || []"></app-filter-multiselect>
            </div>

            <div class="col-12 col-md-4">
              <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Municipality" formControlName="municipality"
                  [options]="filterOptions['municipality'] || []"></app-filter-multiselect>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Organization number</mat-label>
                <input matInput formControlName="company_id" placeholder="Enter organization number" />
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" placeholder="Enter city" />
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              <app-filter-multiselect [loading]="facets.loading()" [loadError]="!!facets.error()" label="Organization type" formControlName="organization_type"
                  [options]="filterOptions['organization_type'] || []"></app-filter-multiselect>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Accounting year</mat-label>
                <input matInput formControlName="accounting_year" placeholder="Enter accounting year" />
              </mat-form-field>
            </div>
          </div>

          <mat-accordion multi class="filter-sections">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Registration filters
                @if (registrationFilterCount > 0) {
                  <span class="filter-section-count">{{ registrationFilterCount }} set</span>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
          <div class="d-flex flex-col gap-8">
            <mat-checkbox formControlName="vat_registered">VAT registered</mat-checkbox>
            <mat-checkbox formControlName="in_company_register">In company register</mat-checkbox>
            <mat-checkbox formControlName="in_foundation_register">In foundation register</mat-checkbox>
            <mat-checkbox formControlName="in_voluntary_register">In voluntary register</mat-checkbox>
            <mat-checkbox formControlName="in_party_register">In party register</mat-checkbox>
          </div>

          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Numeric filters
                @if (numericFilterCount > 0) {
                  <span class="filter-section-count">{{ numericFilterCount }} set</span>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
          <div class="d-flex flex-col gap-16">
          <div formGroupName="number_of_employees" class="numeric-filter d-flex flex-col gap-12">
            <h5 class="m-0 f-s-14 f-w-600">Number of employees</h5>
            <div class="operator-row">
                <mat-form-field appearance="outline">
                    <mat-label>Comparison</mat-label>
                    <mat-select formControlName="operator">
                        @for (op of comparisonOperators; track op.value) {
                            <mat-option [value]="op.value">
                                {{ op.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                @if (filterForm.get('criteria.number_of_employees.operator')?.value !== 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Value</mat-label>
                        <input formControlName="value" matInput placeholder="Enter value" type="number"/>
                    </mat-form-field>
                }

                @if (filterForm.get('criteria.number_of_employees.operator')?.value === 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Min</mat-label>
                        <input formControlName="min" matInput placeholder="Minimum" type="number"/>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Max</mat-label>
                        <input formControlName="max" matInput placeholder="Maximum" type="number"/>
                    </mat-form-field>
                }
            </div>
          </div>

          <div formGroupName="latest_annual_revenue" class="numeric-filter d-flex flex-col gap-12">
            <h5 class="m-0 f-s-14 f-w-600">Latest annual revenue</h5>
            <div class="operator-row">
                <mat-form-field appearance="outline">
                    <mat-label>Comparison</mat-label>
                    <mat-select formControlName="operator">
                        @for (op of comparisonOperators; track op.value) {
                            <mat-option [value]="op.value">
                                {{ op.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                @if (filterForm.get('criteria.latest_annual_revenue.operator')?.value !== 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Value</mat-label>
                        <input formControlName="value" matInput placeholder="Enter value" type="number"/>
                    </mat-form-field>
                }

                @if (filterForm.get('criteria.latest_annual_revenue.operator')?.value === 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Min</mat-label>
                        <input formControlName="min" matInput placeholder="Minimum" type="number"/>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Max</mat-label>
                        <input formControlName="max" matInput placeholder="Maximum" type="number"/>
                    </mat-form-field>
                }
            </div>
          </div>

          <div formGroupName="latest_ebit" class="numeric-filter d-flex flex-col gap-12">
            <h5 class="m-0 f-s-14 f-w-600">Latest EBIT</h5>
            <div class="operator-row">
                <mat-form-field appearance="outline">
                    <mat-label>Comparison</mat-label>
                    <mat-select formControlName="operator">
                        @for (op of comparisonOperators; track op.value) {
                            <mat-option [value]="op.value">
                                {{ op.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                @if (filterForm.get('criteria.latest_ebit.operator')?.value !== 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Value</mat-label>
                        <input formControlName="value" matInput placeholder="Enter value" type="number"/>
                    </mat-form-field>
                }

                @if (filterForm.get('criteria.latest_ebit.operator')?.value === 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Min</mat-label>
                        <input formControlName="min" matInput placeholder="Minimum" type="number"/>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Max</mat-label>
                        <input formControlName="max" matInput placeholder="Maximum" type="number"/>
                    </mat-form-field>
                }
            </div>
          </div>

          <div formGroupName="latest_sum_equity" class="numeric-filter d-flex flex-col gap-12">
            <h5 class="m-0 f-s-14 f-w-600">Latest sum equity</h5>
            <div class="operator-row">
                <mat-form-field appearance="outline">
                    <mat-label>Comparison</mat-label>
                    <mat-select formControlName="operator">
                        @for (op of comparisonOperators; track op.value) {
                            <mat-option [value]="op.value">
                                {{ op.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                @if (filterForm.get('criteria.latest_sum_equity.operator')?.value !== 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Value</mat-label>
                        <input formControlName="value" matInput placeholder="Enter value" type="number"/>
                    </mat-form-field>
                }

                @if (filterForm.get('criteria.latest_sum_equity.operator')?.value === 'between') {
                    <mat-form-field appearance="outline">
                        <mat-label>Min</mat-label>
                        <input formControlName="min" matInput placeholder="Minimum" type="number"/>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Max</mat-label>
                        <input formControlName="max" matInput placeholder="Maximum" type="number"/>
                    </mat-form-field>
                }
            </div>
          </div>
          </div>
          </mat-expansion-panel>
          </mat-accordion>
        </section>

          <div class="action-buttons">
              <button
                      [disabled]="filterForm.invalid || isSaving"
                      class="d-inline-flex align-items-center gap-6"
                      color="primary"
                      mat-flat-button
                      type="submit"
              >
                  <mat-icon>{{ isSaving ? 'hourglass_top' : 'save' }}</mat-icon>
                  {{ editingFilter ? 'Update filter' : 'Create filter' }}
              </button>

              @if (editingFilter) {
                  <button
                          (click)="runCurrentFilter()"
                          [disabled]="localSearchOnly || isSaving || isDeleting || isRunning"
                          class="d-inline-flex align-items-center gap-6"
                          color="primary"
                          mat-stroked-button
                          type="button"
                  >
                      <mat-icon>{{ isRunning ? 'hourglass_top' : 'play_arrow' }}</mat-icon>
                      Run
                  </button>

                  <button
                          (click)="deleteCurrentFilter()"
                          [disabled]="isSaving || isDeleting || isRunning"
                          class="d-inline-flex align-items-center gap-6"
                          color="warn"
                          mat-flat-button
                          type="button"
                  >
                      <mat-icon>delete</mat-icon>
                      Delete
                  </button>
              }

              @if (!isEditMode) {
                  <button
                          (click)="cancel()"
                          [disabled]="isSaving"
                          class="d-inline-flex align-items-center gap-6"
                          color="primary"
                          mat-stroked-button
                          type="button"
                  >
                      <mat-icon>cancel</mat-icon>
                      Cancel
                  </button>
              }
          </div>
      </form>
    </mat-card-content>
        </mat-card>
    }
</div>
